import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Wind, Droplets, ShieldCheck, GlassWater, ArrowRight } from 'lucide-react';

const Home = () => {
  // Produits ECOCLIMA statiques avec les vraies images et prix
  const products = [
    {
      id: 'cloud20',
      name: 'Fontaine Atmosphérique CLOUD20',
      capacity_liters: 20,
      description: 'Parfaite for particuliers et bureaux, cette fontaine produit 20L d\'eau pure par jour directement de l\'air ambiant.',
      features: ['Eau chaude ou froide', 'Ultra-compact', 'Installation simple', 'Filtration 8 étapes'],
      image_url: 'https://customer-assets.emergentagent.com/job_h2o-climate/artifacts/bqpchjq8_cloud20.png',
      price: 2490,
      available_for_purchase: true
    },
    {
      id: 'cloud80',
      name: 'Générateur Résidentiel CLOUD80',
      capacity_liters: 80,
      description: 'Solution idéale pour foyers et petites entreprises, produit jusqu\'à 80L d\'eau pure par jour.',
      features: ['Température ambiante', 'Capacité familiale', 'Économique', 'Bruit ≤65dB'],
      image_url: 'https://customer-assets.emergentagent.com/job_h2o-climate/artifacts/n3kkb3ek_cloud80.png',
      price: 3870,
      available_for_purchase: true
    },
    {
      id: 'cloud250',
      name: 'Générateur Professionnel CLOUD250',
      capacity_liters: 250,
      description: 'Pour hôtels, usines et exploitations nécessitant une production d\'eau importante et constante.',
      features: ['Haute capacité 250L/jour', 'Robuste 350kg', 'Monitoring IoT', 'Support technique'],
      image_url: 'https://customer-assets.emergentagent.com/job_h2o-climate/artifacts/we2metqc_cloud250.png',
      price: 13104,
      available_for_purchase: true
    },
    {
      id: 'cloud500',
      name: 'Générateurs Industriels CLOUD500+',
      capacity_liters: 500,
      description: 'Solutions sur mesure pour grandes industries et collectivités, de 500L à 5000L par jour.',
      features: ['Solutions sur mesure', 'Haute capacité', 'Intégration complète', 'Support dédié'],
      image_url: 'https://customer-assets.emergentagent.com/job_h2o-climate/artifacts/416rjd56_cloud500.png',
      price: 0,
      available_for_purchase: false
    }
  ];

  const testimonials = [
    {
      name: "Client satisfait",
      location: "Petit-Bourg",
      product: "CLOUD80",
      text: "Depuis l'installation de notre CLOUD80, plus de stress avec les coupures d'eau ! L'eau est pure et le goût excellent."
    },
    {
      name: "Entreprise locale",
      location: "Multi-îles",
      product: "CLOUD20",
      text: "18 unités CLOUD20 installées dans nos agences. Nos clients et employés apprécient cette eau pure disponible en permanence."
    },
    {
      name: "Établissement de santé",
      location: "Le Lamentin",
      product: "CLOUD250",
      text: "Une solution parfaite pour notre établissement. L'autonomie hydrique nous rassure et nos résidents sont ravis."
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section 
        className="relative min-h-screen bg-cover bg-center bg-no-repeat text-white flex items-center"
        style={{
          backgroundImage: "url('https://customer-assets.emergentagent.com/job_ecoweb-revamp/artifacts/slhqu5da_IMG_2913.png')"
        }}
      >
        <div className="absolute inset-0 bg-black opacity-40"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-[60vh]">
            <div className="space-y-8">
              <h1 className="text-4xl lg:text-6xl font-bold leading-tight drop-shadow-lg">
                Votre nouvelle source d'eau est dans l'air
              </h1>
              <p className="text-xl lg:text-2xl text-blue-100 drop-shadow-md">
                De 20 à 5000 litres par jour, pour particuliers, entreprises et collectivités
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/produits"
                  className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-colors text-center shadow-lg hover:shadow-xl transform hover:scale-105 duration-300"
                >
                  Voir nos modèles
                </Link>
                <a
                  href="tel:+590590197070"
                  className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 text-center flex items-center justify-center shadow-lg hover:shadow-xl transform hover:scale-105"
                >
                  Appelez-nous
                </a>
                <Link
                  to="/devis"
                  className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-blue-600 transition-colors text-center shadow-lg hover:shadow-xl transform hover:scale-105 duration-300"
                >
                  Demander un devis
                </Link>
              </div>
            </div>
            <div className="hidden lg:block">
              {/* Espace réservé pour équilibrer la mise en page */}
            </div>
          </div>
        </div>
      </section>

      {/* Financement SOGUAFI Section */}
      <section className="py-16 bg-gradient-to-r from-amber-50 to-orange-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center">
              <div className="lg:w-2/3 p-8 lg:p-12">
                <div className="flex items-center mb-4">
                  <svg className="w-8 h-8 text-amber-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  <span className="text-amber-600 font-semibold text-sm uppercase tracking-wide">Facilite de paiement</span>
                </div>
                <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">
                  Payez en plusieurs fois avec SOGUAFI
                </h2>
                <p className="text-gray-600 mb-6 text-lg">
                  Financez votre generateur d'eau atmospherique grace a notre partenaire 
                  <strong> Somafi-Soguafi</strong>, specialiste du credit aux Antilles depuis plus de 50 ans. 
                  Simulez votre financement en quelques clics.
                </p>
                <div className="flex flex-wrap gap-4 mb-6">
                  <div className="flex items-center text-sm text-gray-700">
                    <svg className="w-5 h-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    De 12 a 84 mois
                  </div>
                  <div className="flex items-center text-sm text-gray-700">
                    <svg className="w-5 h-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    Reponse rapide
                  </div>
                  <div className="flex items-center text-sm text-gray-700">
                    <svg className="w-5 h-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    100% en ligne
                  </div>
                </div>
                <Link
                  to="/checkout?paiement=soguafi&duree=36+mois"
                  data-testid="home-soguafi-button"
                  className="inline-flex items-center bg-amber-500 hover:bg-amber-600 text-white px-8 py-3 rounded-lg font-semibold transition-colors"
                >
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  Souscrire avec SOGUAFI
                </Link>
                <p className="text-xs text-gray-500 mt-3">
                  Un credit vous engage et doit etre rembourse. Verifiez vos capacites de remboursement avant de vous engager.
                </p>
              </div>
              <div className="lg:w-1/3 bg-amber-500 p-8 lg:p-12 text-white text-center lg:self-stretch flex flex-col justify-center">
                <div className="text-5xl font-bold mb-2">A partir de</div>
                <div className="text-6xl font-bold mb-2">69€</div>
                <div className="text-xl">/mois*</div>
                <p className="text-amber-100 text-sm mt-4">*Exemple pour le CLOUD20 a 2 490€ sur 36 mois</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="pt-16 pb-8 sm:pt-20 sm:pb-10 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-14">
            <span className="inline-block text-xs font-bold text-green-700 tracking-[0.2em] uppercase mb-3">
              Notre technologie
            </span>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              L'eau pure directement de l'air
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
              Un processus naturel en 4 étapes, de l'humidité atmosphérique à votre verre.
            </p>
          </div>

          {/* Steps with connector line */}
          <div className="relative">
            {/* Desktop horizontal connector */}
            <div className="hidden md:block absolute top-9 left-[12.5%] right-[12.5%] h-0.5 bg-gradient-to-r from-blue-200 via-green-200 to-blue-200" aria-hidden="true" />

            <div className="grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-8 sm:gap-6 relative">
              {[
                { title: 'Captage',      description: "Humidité de l'air",        Icon: Wind,        color: 'text-blue-600',  bg: 'bg-blue-50',  ring: 'ring-blue-100' },
                { title: 'Condensation', description: 'Transformation en eau',    Icon: Droplets,    color: 'text-cyan-600',  bg: 'bg-cyan-50',  ring: 'ring-cyan-100' },
                { title: 'Filtration',   description: 'Purification multi-étapes', Icon: ShieldCheck, color: 'text-green-600', bg: 'bg-green-50', ring: 'ring-green-100' },
                { title: 'Distribution', description: 'Eau pure disponible',      Icon: GlassWater,  color: 'text-blue-500',  bg: 'bg-blue-50',  ring: 'ring-blue-100' },
              ].map((step, idx) => (
                <div key={step.title} className="relative flex flex-col items-center text-center group" data-testid={`process-step-${idx + 1}`}>
                  {/* Step number badge */}
                  <span className="absolute -top-2 right-1/2 translate-x-12 sm:translate-x-14 z-10 bg-gray-900 text-white text-[10px] font-bold w-6 h-6 rounded-full flex items-center justify-center shadow-md">
                    {idx + 1}
                  </span>

                  {/* Icon circle */}
                  <div className={`relative w-16 h-16 sm:w-20 sm:h-20 ${step.bg} rounded-full flex items-center justify-center shadow-md ring-4 ${step.ring} transition-transform duration-300 group-hover:scale-110 z-10`}>
                    <step.Icon className={`w-7 h-7 sm:w-9 sm:h-9 ${step.color}`} strokeWidth={2} />
                  </div>

                  {/* Mobile arrow between steps */}
                  {idx < 3 && (
                    <ArrowRight
                      className="md:hidden absolute top-7 sm:top-9 -right-3 w-4 h-4 text-gray-300"
                      aria-hidden="true"
                    />
                  )}

                  <h3 className="mt-4 text-base sm:text-lg font-bold text-gray-900">{step.title}</h3>
                  <p className="mt-1 text-xs sm:text-sm text-gray-500 leading-snug max-w-[140px]">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="pt-8 pb-16 sm:pt-10 sm:pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-14">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">
              Notre gamme de produits
            </h2>
            <p className="text-base sm:text-lg text-gray-600">
              Des solutions adaptées à tous vos besoins, du particulier aux grandes collectivités
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {products.map((product) => (
              <div key={product.id} className="bg-white rounded-lg shadow-lg overflow-hidden flex flex-col h-full">
                <div className="h-64 bg-gray-50 flex items-center justify-center p-4">
                  <img
                    src={product.image_url}
                    alt={product.name}
                    className="max-h-full max-w-full object-contain"
                    loading="lazy"
                  />
                </div>
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{product.name}</h3>
                  
                  <div className="mb-4">
                    {product.available_for_purchase ? (
                      <div className="space-y-1">
                        <p className="text-2xl font-bold text-blue-600">
                          {product.id === 'cloud500' ? 'De 500 à 5000 L/jour' : `${product.capacity_liters} L/jour`}
                        </p>
                        <p className="text-xl font-bold text-green-600">
                          €{product.price.toLocaleString('fr-FR')}
                        </p>
                      </div>
                    ) : (
                      <div className="space-y-1">
                        <p className="text-2xl font-bold text-blue-600">
                          {product.id === 'cloud500' ? 'De 500 à 5000 L/jour' : `${product.capacity_liters} L/jour`}
                        </p>
                        <p className="text-xl font-semibold text-green-600">
                          Prix sur devis
                        </p>
                      </div>
                    )}
                  </div>
                  
                  <p className="text-gray-600 mb-4 flex-grow">
                    {product.description}
                  </p>
                  <ul className="text-sm text-gray-600 mb-6 space-y-1">
                    {product.features.slice(0, 3).map((feature) => (
                      <li key={feature} className="flex items-center">
                        <svg className="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  
                  <div className="flex flex-col space-y-2 mt-auto">
                    <Link
                      to={product.id === 'cloud500' ? '/generateurs-industriels' : `/produits/${product.id}`}
                      className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-md text-center font-medium transition-colors"
                    >
                      {product.id === 'cloud500' ? 'Voir la gamme industrielle' : 'Plus d\'infos'}
                    </Link>
                    {product.available_for_purchase ? (
                      <Link
                        to={`/checkout?product=${product.id}`}
                        className="bg-green-600 hover:bg-green-700 text-white px-4 py-3 rounded-md text-center font-medium transition-colors"
                      >
                        Acheter maintenant
                      </Link>
                    ) : (
                      <Link
                        to={`/devis?product=${product.id}`}
                        className="border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-4 py-3 rounded-md text-center font-medium transition-colors"
                      >
                        Demander un devis
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Avantages ECOCLIMA
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                title: "Eau potable toute l'année",
                description: "Production continue d'eau pure, indépendamment du réseau public",
                icon: (
                  <svg className="w-12 h-12 text-blue-500" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2c-5.33 4.55-8 8.48-8 11.8c0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2C20 10.48 17.33 6.55 12 2Z"/>
                  </svg>
                )
              },
              {
                title: "Économie garantie",
                description: "0,10€/L contre 1,50€/L pour les bouteilles plastiques",
                icon: (
                  <svg className="w-12 h-12 text-green-500" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2L2 7v10c0 5.55 3.84 9.74 9 9.74s9-4.19 9-9.74V7L12 2Z"/>
                  </svg>
                )
              },
              {
                title: "Zéro déchet plastique",
                description: "Éliminez les bouteilles plastiques et protégez l'environnement",
                icon: (
                  <svg className="w-12 h-12 text-gray-700" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 3V4H4V6H5V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V6H20V4H15V3H9M7 6H17V19H7V6M9 8V17H11V8H9M13 8V17H15V8H13Z"/>
                    <path d="M2 2L22 22L20.73 23.27L18.73 21.27C18.5 21.09 18.26 21 18 21H7C5.9 21 5 20.1 5 19V6.27L1.73 3L3 1.73L4.27 3H9V4H4V6H5V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V6H20V4H15V3H9M7 6H17V19H7V6Z" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.8"/>
                  </svg>
                )
              },
              {
                title: "Solution aux coupures",
                description: "Idéal pour les zones avec coupures d'eau fréquentes",
                icon: (
                  <svg className="w-12 h-12 text-orange-500" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M11 21H12C12.6 21 13 20.6 13 20V16.5L19 12L13 2V7.5L7 12L11 21Z"/>
                  </svg>
                )
              }
            ].map((benefit) => (
              <div key={benefit.title} className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow text-center">
                <div className="flex justify-center mb-4">{benefit.icon}</div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{benefit.title}</h3>
                <p className="text-gray-600 text-sm">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Témoignages clients
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div key={testimonial.name} className="bg-white rounded-lg shadow-lg p-6">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <svg key={`star-${i}`} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <p className="text-gray-600 mb-4 italic">"{testimonial.text}"</p>
                <div className="border-t pt-4">
                  <p className="font-semibold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-500">{testimonial.location}</p>
                  <p className="text-sm text-blue-600 font-medium">{testimonial.product}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Environmental Impact Section */}
      <section className="py-20 bg-green-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Impact écologique
            </h2>
            <p className="text-xl text-gray-600">
              Ensemble, préservons nos plages caribéennes et réduisons notre empreinte environnementale
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                number: "5M",
                unit: "bouteilles/an",
                description: "Plastique évité"
              },
              {
                number: "500",
                unit: "tonnes CO₂/an",
                description: "Réduction d'émissions"
              },
              {
                number: "50",
                unit: "emplois locaux",
                description: "Créés d'ici 2027"
              }
            ].map((stat) => (
              <div key={stat.number} className="text-center">
                <div className="text-4xl lg:text-6xl font-bold text-green-600 mb-2">{stat.number}</div>
                <div className="text-lg font-medium text-gray-900 mb-1">{stat.unit}</div>
                <div className="text-gray-600">{stat.description}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-blue-600 text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-bold mb-6">
            Ne dépendez plus du réseau, devenez maître de votre eau
          </h2>
          <p className="text-xl mb-8">
            Contactez-nous dès aujourd'hui pour une étude personnalisée et un devis gratuit
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+590590197070"
              className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              Appelez maintenant
            </a>
            <Link
              to="/devis"
              className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
            >
              Demander un devis
            </Link>
            <Link
              to="/contact"
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors"
            >
              Nous contacter
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;